import { CaretCircleUp } from '@phosphor-icons/react';

export default CaretCircleUp;